import { takeLatest } from 'redux-saga/effects'
import { REFRESH_TOKEN_SAGA } from 'src/store/types/auth'
import refreshToken from './refreshToken'

export function* refreshTokenSaga() {
  yield takeLatest(REFRESH_TOKEN_SAGA, refreshToken)
}
